import React from 'react';
import ConditionalStatemensES from './ConditionalStatemensES';
import ConditionalStatemensEN from './ConditionalStatemensEN';
import useLanguage from '../../customHooks/useLanguage';

const CookieConsentConditional = () => {
    const language = useLanguage();

    const translatedCookie = {
        en: <ConditionalStatemensEN />,
        es: <ConditionalStatemensES />,
        fr: <ConditionalStatemensEN />,
        de: <ConditionalStatemensEN />,
    };

    const getTranslatedCookie = currentLanguage => {
        return translatedCookie[currentLanguage];
    };

    return <div>{getTranslatedCookie(language)}</div>;
};

export default CookieConsentConditional;
